import React, { useState, useRef, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { Growl } from 'primereact/growl';
import Dropzone from 'react-dropzone';

import servicioObjetos from '../../servicio/ServicioObjetos';
import servicioHttp from '../../servicio/ServicioHttp';
import { obtenerObjetoBase64Archivos } from '../../servicio/ServicioLecturaArchivos';
import { validacionCertificadosDigitales } from '../../servicio/ServicioValidacionCertificadosDigitales';
import forge from 'node-forge';

import {ModalResponseAuthIdseImms} from './ModalResponseAuthIdseImms';

const MENSAJE_PFX = "Arrastra tu Certificado .PFX o da click aquí";
const MENSAJE_FIEL = "Arrastra tu FIEL(.cer y .key) o da click aquí";
const ACEPTAR_PFX = ".pfx";
const ACEPTAR_FIEL = ".cer,.key";
export const ModalAgregarEmpresa = (props) => {

    let growl = useRef(null);
    const { mostrarModal, funcionCerrarModal } = props;
    // const [empresa, setEmpresa] = useState({
    //     usuario: "Y6653422102",
    //     rfc: "PIOC8908186U7",
    //     registroPatronal: "Y6653422102",
    //     razonSocial: "ALTA ADMINISTRACION OPERATIVA AAG S.A. DE C.V.",
    //     nombreCortoRazonSocial: "ALTA ADMINISTRACION OPERATIVA",
    //     representanteLegal: "LEGAL",
    //     actividadEconomica: "ACTIVIDAD",
    //     contrasenaPfx: "ORC880301",
    //     rfcFiel: "EKU9003173C9"
    // });
    const [empresa, setEmpresa] = useState({});
    const [errores, setErrores] = useState({});
    const [archivoPfx, setArchivoPfx] = useState({});
    const [archivoCer, setArchivoCer] = useState({});
    const [archivoKey, setArchivoKey] = useState({});
    const [mostrarModalAuthResponse,setMostrarModalAuthResponse]=useState(false);
    const [objetoResponseAuth,setObjetoResponseAuth]=useState({});

    useEffect(() => {
        setEmpresa({});
        setErrores({});
        setArchivoCer({});
        setArchivoKey({});
        setArchivoPfx({});
    }, [mostrarModal]);

    const handleChange = (e, mayusculas) => {
        const { name, value } = e.target;
        let elValor = value;
        if (mayusculas) {
            if (elValor && typeof elValor !== 'object')
                elValor = elValor.toUpperCase();
        }
        setEmpresa(valoresPrevios => ({
            ...valoresPrevios,
            [name]: elValor
        }));
    };

    const cerrarModal = () => {
        funcionCerrarModal(false);
    }

    const asignarArchivos = (objetoValidacion, archivo) => {
        return new Promise((resolve, reject) => {           
            obtenerObjetoBase64Archivos(objetoValidacion, archivo);
            resolve(objetoValidacion);
        });
    }

    const onDrop = (files) => {
        for (var i = 0; i < files.length; i++) {
            const archivo = files[i];
            if (archivo.name.toLowerCase().endsWith(".pfx")) {
                let objetoValidacion = {};               
                asignarArchivos(objetoValidacion,archivo).then(response => {
                    setTimeout(() => {
                        setArchivoPfx(response);
                     }, 50);
                });
            }
            if (archivo.name.toLowerCase().endsWith(".cer")) {
                let objetoValidacion = {};
                asignarArchivos(objetoValidacion,archivo).then(response => {                
                    setTimeout(() => {
                        setArchivoCer(response);
                     }, 50);
                });
            }
            if (archivo.name.toLowerCase().endsWith(".key")) {
                let objetoValidacion = {};
                asignarArchivos(objetoValidacion,archivo).then(response => {
                    setTimeout(() => {
                        setArchivoKey(response); 
                     }, 50);
                });
            }
        }
    }

    const guardar = () => {
        const validacion = validarFormulario();
        setErrores(validacion);
        if (servicioObjetos.esObjetoVacio(validacion)) {
            let empresaEnvio = {};
            empresaEnvio.id = null;
            empresaEnvio.usuario = empresa.usuario;
            empresaEnvio.contrasena = empresa.contrasenaPfx;
            empresaEnvio.archivoPfx = archivoPfx.stringBase64;
            empresaEnvio.rfc = empresa.rfc;
            empresaEnvio.registroPatronal = empresa.registroPatronal;
            empresaEnvio.razonSocial = empresa.razonSocial;
            empresaEnvio.representanteLegal = empresa.representanteLegal;
            empresaEnvio.actividadEconomica = empresa.actividadEconomica;
            empresaEnvio.certificadorCer = archivoCer.stringBase64;
            empresaEnvio.certificadoKey = archivoKey.stringBase64;
            empresaEnvio.contraseniaFiel = empresa.contrasenaFiel;
            empresaEnvio.rfcFiel = empresa.rfcFiel;
            empresaEnvio.fechaCreacion = empresa.fechaCreacion;
            empresaEnvio.fechaExpiracion = empresa.fechaExpiracion;
            empresaEnvio.estado = 0;
            empresaEnvio.nombreCortoRazonSocial = empresa.nombreCortoRazonSocial;
            empresaEnvio.nombreArchivo = archivoPfx.nombre;
            empresaEnvio.tipoCertificado = empresa.tipoCertificado;
            if(empresaEnvio.tipoCertificado === 'fiel'){
                empresaEnvio.usuario = null;
                empresaEnvio.contrasena = null;
                empresaEnvio.archivoPfx = null;
            }
            if(empresaEnvio.tipoCertificado === 'pfx'){
                empresaEnvio.certificadoCer = null;
                empresaEnvio.certificadoKey = null;
                empresaEnvio.contraseniaFiel = null;
                empresaEnvio.rfcFiel=null;
            }
            servicioHttp.consumirPostHttp("empresa/guardar.json", empresaEnvio).then(response => {
                growl.current.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje,life:10000 });
                let {objeto}=response.data;

                if(!servicioObjetos.esObjetoVacio(objeto)){
                    setMostrarModalAuthResponse(true);
                    setObjetoResponseAuth(objeto);
                }
                if (!response.data.error) {
                    cerrarModal();
                    cerrarModalAuth();
                }
            }).catch(error => {
                growl.current.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }


    const validarFormulario = () => {
        const errores = {};
        var expreReg = /^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$/;
        var validacionRFC = expreReg.exec(empresa.rfc);

        if (servicioObjetos.esObjetoVacio(empresa.usuario))
            errores.usuario = "Campo requerido";

        if (!validacionRFC) {
            errores.rfc = "Ingrese RFC";
        }
        if (servicioObjetos.esObjetoVacio(empresa.registroPatronal))
            errores.registroPatronal = "Ingrese Registro Patronal";

        if (servicioObjetos.esObjetoVacio(empresa.razonSocial))
            errores.razonSocial = "Campo requerido";
        if (servicioObjetos.esObjetoVacio(empresa.representanteLegal))
            errores.representanteLegal = "Campo requerido";
        if (servicioObjetos.esObjetoVacio(empresa.actividadEconomica))
            errores.actividadEconomica = "Campo requerido";
        if (servicioObjetos.esObjetoVacio(empresa.nombreCortoRazonSocial))
            errores.nombreCortoRazonSocial = "Campo requerido";
        if (servicioObjetos.esObjetoVacio(empresa.tipoCertificado))
            errores.tipoCertificado = "Campo requerido";

        if (!servicioObjetos.esObjetoVacio(empresa.tipoCertificado)) {
            if (empresa.tipoCertificado === 'pfx') {
                if (servicioObjetos.esObjetoVacio(empresa.contrasenaPfx)) {
                    errores.contrasenaPfx = "Campo requerido";
                }
                if (servicioObjetos.esObjetoVacio(archivoPfx)) {
                    errores.tipoCertificado = "Debes de cargar un archivo .pfx";
                } else {
                    const validacionPfx = validarCertificadoPfx(archivoPfx.stringBase64, empresa.contrasenaPfx);
                    empresa.fechaExpiracion = validacionPfx.fecha;
                    if (validacionPfx.error) {
                        errores.contrasenaPfx = validacionPfx.descripcionError;
                    }
                }
            }

            if (empresa.tipoCertificado === 'fiel') {
                if (servicioObjetos.esObjetoVacio(archivoCer) || servicioObjetos.esObjetoVacio(archivoKey)) {
                    errores.tipoCertificado = "No has cargado .cer o .key";
                }

                if (servicioObjetos.esObjetoVacio(empresa.rfcFiel)) {
                    errores.rfcFiel = "El rfc de la fiel es requerido";
                } else if (servicioObjetos.esObjetoVacio(empresa.contrasenaFiel)) {
                    errores.contrasenaFiel = "Campo requerido";
                } else {
                    try {
                        let validacionCertificado = validacionCertificadosDigitales(archivoCer.stringBase64, archivoKey.stringBase64, empresa.contrasenaFiel, empresa.rfcFiel, "FIEL");
                        empresa.fechaExpiracion = validacionCertificado.fechaFinal.getTime();
                        empresa.fechaCreacion = validacionCertificado.fechaInicial.getTime();
                    } catch (e) {
                        console.log(e);
                        errores.contrasenaFiel = e.message;
                    }
                }
            }

        }
        return errores;
    }


    const validarCertificadoPfx = (archivoPfxB64, password) => {
        const validacionPfx = {};
        var p12Der = forge.util.decode64(archivoPfxB64);
        var p12Asn1 = forge.asn1.fromDer(p12Der);
        let p12 = null;
        try {
            p12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, password);
            var bags = p12.getBags({ bagType: forge.pki.oids.certBag });
            var certificado2 = bags[forge.pki.oids.certBag][1];
            validacionPfx.fecha = certificado2.cert.validity.notAfter;
            validacionPfx.error = false;
        } catch (e) {
            validacionPfx.error = true;
            validacionPfx.descripcionError = "La contraseña del archivo .pfx es incorrecta";
        }
        return validacionPfx;
    }


    const validarTipoFiel = (event) => {
        handleChange(event, false);
        setArchivoCer({});
        setArchivoKey({});
        setArchivoPfx({});
    }

    const cerrarModalAuth= () => {
        setMostrarModalAuthResponse(false);
        setObjetoResponseAuth({});
    }

    const pieDialogo = <div className="ui-dialog-buttonpane p-clearfix">

        <Button
            label="Guardar"
            icon="pi-md-save"
            onClick={guardar} />
        <Button
            label="Cancelar"
            icon="pi-md-close"
            onClick={cerrarModal}
            className="p-button-danger " />
    </div>;

    return (
        <div>
            <Growl ref={growl} />
            <ModalResponseAuthIdseImms mostrar={mostrarModalAuthResponse}
            funcionCerrar={cerrarModalAuth}
            objetoResponseAuth={objetoResponseAuth}/>
            <Dialog
                visible={mostrarModal}
                style={{ width: '80%' }}
                appendTo={document.body}
                header="Administración de patrones"
                modal={true} footer={pieDialogo}
                onHide={cerrarModal}>
                <div className="card">
                    <h4>Los campos con (*) son obligatorios, por favor captura los datos de la Empresa</h4>
                    <div className="p-grid form-group">
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="11" id="registroPatronal"
                                    name="registroPatronal" value={empresa.registroPatronal || ""}
                                    className={errores.registroPatronal ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)}
                                    style={{ width: "90%" }} />
                                <label>* Registro Patronal:</label>
                                {errores.registroPatronal ? <div><Message severity="error"
                                    text={errores.registroPatronal} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="200" id="razonSocial"
                                    name="razonSocial" value={empresa.razonSocial || ""}
                                    className={errores.razonSocial ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                <label>* Razón Social:</label>
                                {errores.razonSocial ? <div><Message severity="error"
                                    text={errores.razonSocial} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="100" id="nombreCortoRazonSocial"
                                    name="nombreCortoRazonSocial"
                                    value={empresa.nombreCortoRazonSocial || ""}
                                    className={errores.nombreCortoRazonSocial ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                <label>* Nombre corto razón Social:</label>
                                {errores.nombreCortoRazonSocial ? <div><Message severity="error"
                                    text={errores.nombreCortoRazonSocial} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="13" id="rfc"
                                    name="rfc" value={empresa.rfc || ""}
                                    className={errores.rfc ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                <label>* Rfc Empresa:</label>
                                {errores.rfc ? <div><Message severity="error" text={errores.rfc} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="200" id="representanteLegal"
                                    name="representanteLegal" value={empresa.representanteLegal || ""}
                                    className={errores.representanteLegal ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                <label>* Representante Legal:</label>
                                {errores.representanteLegal ? <div><Message severity="error"
                                    text={errores.representanteLegal} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="200" id="actividadEconomica"
                                    name="actividadEconomica" value={empresa.actividadEconomica || ""}
                                    className={errores.actividadEconomica ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                <label>* Actividad Economica:</label>
                                {errores.actividadEconomica ? <div><Message severity="error"
                                    text={errores.actividadEconomica} /> </div> : null}
                            </span>
                        </div>


                        <div className="p-col-12 p-md-6">
                            <span className="md-inputfield">
                                <InputText type="text" maxLength="200" id="usuario"
                                    name="usuario" value={empresa.usuario || ""}
                                    className={errores.usuario ? "p-error" : ""}
                                    onChange={(e) => handleChange(e, false)} style={{ width: "90%" }} />
                                <label>* Usuario Idse:</label>
                                {errores.usuario ? <div><Message severity="error" text={errores.usuario} /> </div> : null}
                            </span>
                        </div>

                        <div className="p-col-12 p-md-6">
                            <RadioButton inputId="pfx" name="tipoCertificado" value="pfx"
                                onChange={validarTipoFiel}
                                checked={empresa.tipoCertificado === 'pfx'} />
                            <label htmlFor="pfx" className="p-radiobutton-label">Conectar con Certificado .PFX  </label>
                            <RadioButton inputId="fiel" name="tipoCertificado" value="fiel"
                                onChange={validarTipoFiel}
                                checked={empresa.tipoCertificado === 'fiel'} />
                            <label htmlFor="fiel" className="p-radiobutton-label">Conectar con Fiel</label>
                            {errores.tipoCertificado ? <div><Message severity="error" text={errores.tipoCertificado} /> </div> : null}
                        </div>

                        {!servicioObjetos.esObjetoVacio(empresa.tipoCertificado) && empresa.tipoCertificado === "pfx" ?
                            <div className="p-col-12 p-md-6">
                                <span className="md-inputfield">
                                    <InputText type="password" maxLength="200" id="contrasenaPfx"
                                        name="contrasenaPfx" value={empresa.contrasenaPfx || ""}
                                        className={errores.contrasenaPfx ? "p-error" : ""}
                                        onChange={handleChange} style={{ width: "90%" }} />
                                    <label>* Contraseña Certificado .PFX:</label>
                                    {errores.contrasenaPfx ? <div>
                                        <Message severity="error" text={errores.contrasenaPfx} /> </div> : null}
                                </span>
                            </div> : null}


                        {!servicioObjetos.esObjetoVacio(empresa.tipoCertificado) && empresa.tipoCertificado === "fiel" ?
                            <div className="p-col-6 p-md-6">
                                <span className="md-inputfield">
                                    <InputText type="password" maxLength="200" id="contrasenaFiel"
                                        name="contrasenaFiel"
                                        value={empresa.contrasenaFiel || ""}
                                        className={errores.contrasenaFiel ? "p-error" : ""}
                                        onChange={handleChange} style={{ width: "90%" }} />
                                    <label>* Contraseña Certificado FIEL:</label>
                                    {errores.contrasenaFiel ? <div>
                                        <Message severity="error" text={errores.contrasenaFiel} /> </div> : null}
                                </span>
                            </div>

                            : null}

                        {!servicioObjetos.esObjetoVacio(empresa.tipoCertificado) && empresa.tipoCertificado === "fiel" ?
                            <div className="p-col-6 p-md-6">
                                <span className="md-inputfield">
                                    <InputText type="text" maxLength="13"
                                        id="rfcFiel" name="rfcFiel"
                                        value={empresa.rfcFiel || ""}
                                        className={errores.rfcFiel ? "p-error" : ""}
                                        onChange={(e) => handleChange(e, true)} style={{ width: "90%" }} />
                                    <label>* Rfc de la FIEL:</label>
                                    {errores.rfcFiel ? <div><Message
                                        severity="error" text={errores.rfcFiel} /> </div> : null}
                                </span>
                            </div>

                            : null}
                        {!servicioObjetos.esObjetoVacio(empresa.tipoCertificado) ?
                            <div className="p-col-12 p-md-12">
                                <Dropzone accept={empresa.tipoCertificado === 'pfx' ? ACEPTAR_PFX : ACEPTAR_FIEL} onDrop={onDrop}>
                                    {({ getRootProps, getInputProps }) => (
                                        <section >
                                            <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                                                <input   {...getInputProps()} />
                                                <center><p>{servicioObjetos.esObjetoVacio(empresa.tipoCertificado) ? null :
                                                    empresa.tipoCertificado === "fiel" ? MENSAJE_FIEL : MENSAJE_PFX}</p></center>
                                            </div>
                                            <br></br>
                                            {!servicioObjetos.esObjetoVacio(archivoPfx) ?
                                                <div><strong>{archivoPfx.nombre}</strong></div> : null}
                                            {!servicioObjetos.esObjetoVacio(archivoCer) ?
                                                <div><strong>{archivoCer.nombre}</strong></div> : null}
                                            {!servicioObjetos.esObjetoVacio(archivoKey) ?
                                                <div><strong>{archivoKey.nombre}</strong></div> : null}
                                        </section>
                                    )}
                                </Dropzone>
                            </div> : null}
                    </div>
                </div>
            </Dialog>
        </div>
    );
}